import {ChangeDetectorRef, Component, ElementRef, forwardRef} from "@angular/core";
import {NG_VALUE_ACCESSOR} from "@angular/forms";
import {FUIAbstractSelectInput} from "../abstract-select-input";
import {FUIOptionsService} from "../../../framework/options.service";
import {FUIEventsService} from "../../../../events/events.service";
@Component({
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            useExisting: forwardRef(() => FUIFilterSelectInputComponent),
            multi: true
        }
    ],
    selector: "fui-filter-select-input",
    styleUrls: ["../select-input.scss"],
    templateUrl: "./filter-select-input.component.html",
    standalone: false
})
export class FUIFilterSelectInputComponent extends FUIAbstractSelectInput {
    constructor(elementRef: ElementRef,
                changeDetectorRef: ChangeDetectorRef,
                eventsService: FUIEventsService,
                optionsService: FUIOptionsService) {
        super(elementRef, changeDetectorRef, eventsService, optionsService);
    }
}
